(function($) {
    var documentLoad = function() {
        $('.file-gallery-module .file-tile').matchHeight();
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/file-gallery.js